import { NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { IcmsIcons } from '@icms/ui/icons/generated/icms-icons';
import { defaultImagePng } from '../../icms.config';
import { ICmsContentVariant, ICmsContentVideoProvider } from './components.interface';
export function getCmsContentFieldConfig(imageKey: string, imageTitle = 'Image'): NICmsContentField.IField[] {
    return [
        <NICmsContentField.IChoiceField>{
            key: 'contentVariant',
            type: NICmsContentField.EFieldType.choice,
            title: 'Variant',
            options: [
                {
                    key: ICmsContentVariant.image,
                    title: 'Image'
                },
                {
                    key: ICmsContentVariant.video,
                    title: 'Video'
                }
            ],
            default: ICmsContentVariant.image
        },
        <NICmsContentField.IField>{
            key: imageKey,
            title: imageTitle,
            description: 'If video variant is selected, image will be under the video as a poster',
            type: NICmsContentField.EFieldType.image,
            default: defaultImagePng
        },
        <NICmsContentField.IChoiceField>{
            key: 'contentVideoProvider',
            type: NICmsContentField.EFieldType.choice,
            title: 'Variant',
            options: [
                {
                    key: ICmsContentVideoProvider.vimeo,
                    title: 'Vimeo'
                },
                {
                    key: ICmsContentVideoProvider.youtube,
                    title: 'Youtube'
                }
            ],
            default: ICmsContentVideoProvider.vimeo,
            canShow: data => data?.contentVariant === ICmsContentVariant.video
        },
        <NICmsContentField.IField>{
            key: 'contentVideoId',
            title: 'Video Id',
            type: NICmsContentField.EFieldType.text,
            canShow: data => data?.contentVariant === ICmsContentVariant.video
        }
    ];
}
export const PROMOTION_FIELDS: NICmsContentField.IField[] = [
    <NICmsContentField.IField>{
        key: 'promotionSectionLabel',
        type: NICmsContentField.EFieldType.label,
        title: 'Promotion'
    },
    {
        key: 'promotionEnabled',
        type: NICmsContentField.EFieldType.toggle,
        title: 'Enabled',
        default: false
    },
    <NICmsContentField.IField>{
        key: 'promotionId',
        type: NICmsContentField.EFieldType.text,
        title: 'ID',
        default: 'promotion id',
        required: true
    },
    <NICmsContentField.IField>{
        key: 'promotionName',
        type: NICmsContentField.EFieldType.text,
        title: 'Name'
    },
    <NICmsContentField.IField>{
        key: 'promotionCreative',
        type: NICmsContentField.EFieldType.text,
        title: 'Creative'
    },
    <NICmsContentField.INumberField>{
        key: 'promotionPosition',
        type: NICmsContentField.EFieldType.number,
        title: 'Position',
        default: 1
    }
];

export const ICMS_GROUP_ADDITIONAL_ID = 'additional';

NICmsContentComponent.fieldGroupIcons[ICMS_GROUP_ADDITIONAL_ID] = IcmsIcons.MoreVert;
